import api from './api'

function buildQuery(params = {}) {
  const q = new URLSearchParams()
  if (params.name) q.append('name', params.name)
  if (params.phone) q.append('phone', params.phone)
  if (params.customerTypeId != null && params.customerTypeId !== '') {
    q.append('customerTypeId', String(params.customerTypeId))
  }
  if (params.linked === true || params.linked === false) {
    q.append('linked', String(params.linked))
  }
  q.append('page', params.page ?? 0)
  q.append('size', params.size ?? 10)
  return q.toString()
}

export const therapyCustomerService = {
  fetchList(params) {
    return api.get(`/therapy/customers?${buildQuery(params)}`)
  },
  get(id) {
    return api.get(`/therapy/customers/${id}`)
  },
  create(payload) {
    return api.post('/therapy/customers', payload)
  },
  update(id, payload) {
    return api.put(`/therapy/customers/${id}`, payload)
  },
  patchCustomerType(id, customerTypeId) {
    return api.patch(`/therapy/customers/${id}/customer-type`, { customerTypeId })
  },
  unlinkWechat(id) {
    return api.post(`/therapy/customers/${id}/unlink-wechat`)
  },
  fetchBookings(id, page = 0, size = 10) {
    return api.get(`/therapy/customers/${id}/bookings?page=${page}&size=${size}`)
  },
  fetchReviews(id, page = 0, size = 10) {
    return api.get(`/therapy/customers/${id}/reviews?page=${page}&size=${size}`)
  },

  async downloadImportTemplate() {
    const res = await api.get('/therapy/customers/import/template', {
      responseType: 'blob',
      timeout: 60000
    })
    const blob = res.data
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = 'therapy_customer_import_template.xlsx'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  },

  importFromExcel(file) {
    const formData = new FormData()
    formData.append('file', file)
    return api.post('/therapy/customers/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 300000
    })
  }
}
